import { ArrowDown } from 'lucide-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { plainSummaryExcerpt, summaryLooksLikeRawPayload } from '@/utils/run-summary'
import { Section } from './Section'

/**
 * ReportSummary — the report's at-a-glance excerpt, paired beside Zadání at
 * the top of the detail page. The full report renders inline lower on the
 * page; "Číst celý report" scrolls there (`onReadFull`).
 */
export function ReportSummary({
  summary,
  onReadFull,
}: {
  summary: string | null
  onReadFull: () => void
}) {
  const { t } = useTranslation()
  const excerpt = useMemo(
    () => (summary && !summaryLooksLikeRawPayload(summary) ? plainSummaryExcerpt(summary) : null),
    [summary]
  )

  return (
    <Section
      title={t('search.detail.reportSummary.title')}
      hint={t('search.detail.reportSummary.hint')}
    >
      <div className="flex flex-col gap-3">
        {excerpt ? (
          <p className="line-clamp-5 whitespace-pre-line break-words text-sm leading-relaxed text-foreground">
            {excerpt}
          </p>
        ) : (
          <p className="text-sm italic text-muted-foreground">
            {t('search.detail.reportSummary.empty')}
          </p>
        )}
        <Button
          type="button"
          size="sm"
          className="group self-start gap-1.5 max-md:h-9"
          onClick={onReadFull}
        >
          {t('search.detail.reportSummary.readFull')}
          <ArrowDown className="size-3.5 transition-transform group-hover:translate-y-0.5" />
        </Button>
      </div>
    </Section>
  )
}
